import {
  action, flow, observable, makeObservable,
} from 'mobx';
import BaseStore from './BaseStore';

import CPFOffersAPI from '../api/cpf_offers';
import { CPFSortTypes } from '../constants/CPFSortTypes';

class CPFOffersStore extends BaseStore {
  offers = [];
  isOffersDataLoading = false;
  latitude;
  longitude;
  sortType = CPFSortTypes.DISTANCE;
  schoolId;
  location;

  constructor() {
    super();

    makeObservable(this, {
      offers: observable,
      isOffersDataLoading: observable,
      latitude: observable,
      longitude: observable,
      sortType: observable,
      schoolId: observable,
      location: observable,
      setCoordinates: action.bound,
      setSchoolId: action.bound,
      setSortType: action.bound,
      setLocation: action.bound,
    });
  }

  setCoordinates({ latitude, longitude }) {
    this.latitude = latitude;
    this.longitude = longitude;
  }

  setSchoolId(schoolId) {
    this.schoolId = schoolId;
  }

  setSortType(sortType) {
    this.sortType = sortType;
  }

  setLocation(location) {
    this.location = location;
  }

  getOffers = flow(
    function* () {
      this.isOffersDataLoading = true;
      try {
        if (this.latitude && this.longitude) {
          const { data } = yield CPFOffersAPI.getOffersByCoordinates(this.latitude, this.longitude, this.sortType);
          this.offers = data.schools;
        } else if (this.schoolId) {
          const { data } = yield CPFOffersAPI.getOffersBySchoolId(this.schoolId, this.sortType);
          this.offers = data.schools;
        }
      } finally {
        this.isOffersDataLoading = false;
      }
    },
  );
}

export default new CPFOffersStore();
